import React from 'react';

import store from '../../store';
import {updateTutorial} from '../../actions/Signin'

import PackageList from './images/package-list.svg';
import SpecialHandling from './images/special-handling.svg';
import DamagedItem from './images/damaged-item.svg';
import ItemDescription from './images/item-description.svg';

import './styles.css';

const TUTORIAL_DATA = {
  cart_tutorial: [
    {
      index: 0,
      title: 'Package List',
      desc: `Packages in your cart will be listed by courier tracking number
      instead of the usual generic description.`,
      img: PackageList,
    },
    {
      index: 1,
      title: 'Special Handling',
      desc:
        'This icon will let you know if your package requires special handling',
      img: SpecialHandling,
    },
    {
      index: 2,
      title: 'Damaged Item',
      desc:
        'This icon will let you know if your package contains a damaged item.',
      img: DamagedItem,
    },
  ],
  item_tutorial: [
    {
      index: 0,
      title: 'Item Description',
      desc: `Each item inside your package will be listed in this section. Item description may either be manually encoded or captured automatically from Universal Product Code records.`,
      img: ItemDescription,
    },
  ],
};

class CartTutorial extends React.Component {
  state = {
    activeItem: {},
    isShown: true
  }

  componentDidMount() {
    const tutorialDataAccount =
      this.props.accountDetails && JSON.parse(this.props.accountDetails.party.metadata)[this.props.type];
    if (tutorialDataAccount) {
      this.setState({isShown: false});
      return;
    }
    this.setState({
      activeItem: TUTORIAL_DATA[this.props.type][0]
    });
  }

  handleClick = () => {
    if (this.state.activeItem.index === TUTORIAL_DATA[this.props.type].length - 1) {
      store.dispatch(updateTutorial(this.props.type));
      this.setState({isShown: false});
      return;
    }
    this.setState({
      activeItem: TUTORIAL_DATA[this.props.type][this.state.activeItem.index + 1]
    });

  }
  render () {
    return this.state.isShown ? (
      <div className="tutorial-BG" onClick={() => this.handleClick()}>
        <div className="tutorial-content"  onClick={() => this.handleClick()}>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }} >
            <img src={this.state.activeItem.img} alt="Package List" />
          </div>
          <p style={{
            fontSize: '26px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontWeight: 600,
          }} >{this.state.activeItem.title}</p>
          <p style={{ 
            fontSize: '14px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: 350,
            textAlign: 'center' }} >
    {this.state.activeItem.desc}</p>
        </div>
      </div>
    ) : null
  }
}

export default CartTutorial;


/** WEBPACK FOOTER **
 ** ./src/components/Tutorial/index.js
 **/